module.exports = __webpack_public_path__ + "static/media/presetsView.9cf934c1.png";